import { atomWithStorage, createJSONStorage } from 'jotai/utils';

const storage = createJSONStorage<boolean>(() => sessionStorage);

const STORAGE_KEY = 'isAiHubWelcomeModalShown';

export const isAiHubWelcomeModalShownAtom = atomWithStorage(
  STORAGE_KEY,
  true,
  storage,
);
